import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuardService } from './common/auth-guard.service';
import { HomeComponent } from '../app/inside-of-application/home/home.component';
import { DashboardComponent } from '../app/inside-of-application/dashboard/dashboard.component';
import { BadRequestComponent } from '../app/out-of-application/bad-request/bad-request.component';
import { PageNotFoundComponent } from '../app/out-of-application/page-not-found/page-not-found.component';
import { LogoutComponent } from '../app/out-of-application/logout/logout.component';
import { UnAuthorizeComponent } from '../app/out-of-application/un-authorize/un-authorize.component';
import { SessionExpiredComponent } from './out-of-application/session-expired/session-expired.component';
import { LoginComponent } from './out-of-application/login/login.component';
import { DummyLoginComponent } from './out-of-application/dummy-login/dummy-login.component';
import { ResumeComponent } from './inside-of-application/resume/resume.component';
import { AddDelegateComponent } from './inside-of-application/delegate/add-delegate/add-delegate.component';
import { ViewDelegateComponent } from './inside-of-application/delegate/view-delegate/view-delegate.component';
import { CreateResumeComponent } from './inside-of-application/resume/create-resume/create-resume.component';
import { MyResumeComponent } from './inside-of-application/resume/my-resume/my-resume.component';
import { SearchResumeComponent } from './inside-of-application/search-resume/search-resume.component';
import { ResuemeCartComponent } from './inside-of-application/resueme-cart/resueme-cart.component';
import { ConsentComponent } from './out-of-application/consent/consent.component';
const routes: Routes = [
    { path: 'login/:id', component: LoginComponent },
    { path: 'login', component: LoginComponent },
    { path: '', redirectTo: 'login', pathMatch: 'full' },
    { path: 'dummylogin', component: DummyLoginComponent },
    { path: 'logout', component: LogoutComponent },
    { path: 'unauthorize', component: UnAuthorizeComponent },
    { path: 'badrequest', component: BadRequestComponent },
    { path: 'pagenotfound', component: PageNotFoundComponent },
    { path: 'sessionexpired', component: SessionExpiredComponent },
    { path: 'Consent', component: ConsentComponent },
    {
        path: 'home', component: HomeComponent, canActivate: [AuthGuardService],
        children: [
            {
                path: '', component: DashboardComponent, canActivate: [AuthGuardService]
            },
            {
                path: 'dashboard', component: DashboardComponent, canActivate: [AuthGuardService]
            },
            {
                path: 'new/:id', component: DashboardComponent, canActivate: [AuthGuardService]
            },
            {
                path: 'new', component: DashboardComponent, canActivate: [AuthGuardService]
            },
            {
                path: 'resume', component: ResumeComponent, canActivate: [AuthGuardService]
            },
            {
                path: 'add-delegate',
                component: AddDelegateComponent, canActivate: [AuthGuardService]
            },
            {
                path: 'add-delegate/:ID',
                component: AddDelegateComponent, canActivate: [AuthGuardService]
            },
            {
                path: 'resume/:ID', component: ResumeComponent, canActivate: [AuthGuardService]
            },
            {
                path: 'view-delegate', canActivate: [AuthGuardService],
                component: ViewDelegateComponent
            },
            {
                path: 'create-resume', component: CreateResumeComponent, canActivate: [AuthGuardService]
            },
            {
                path: 'my-resume', component: MyResumeComponent, canActivate: [AuthGuardService]
            },
            {
                path: 'SearchResume', component: SearchResumeComponent, canActivate: [AuthGuardService]
            }
            ,
            {
                path: 'ResumeCart', component: ResuemeCartComponent, canActivate: [AuthGuardService]
            }
        ]
    },
    { path: '**', redirectTo: 'pagenotfound' }
];

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule],
    providers: [AuthGuardService]
})
export class AppRoutingModule {
}
